<template>
  <v-container fluid>
    <v-form id="bug-form" v-model="valid" ref="form" class="wrapper lg mx-auto pa-4 mt-4">
      <v-layout row wrap>
        <v-flex xs6 pa-3>
          <v-text-field
               label="Your Name"
               v-model="user.name"
               disabled
               class="input-group--focused"
               ></v-text-field>
        </v-flex>
        <v-flex xs6 pa-3>
          <v-text-field
               label="Your E-mail"
               v-model="user.email"
               disabled
               ></v-text-field>
        </v-flex>
        <v-flex xs6 pa-3>
          <v-select
               :items="severities"
               v-model="severity"
               label="Severity"
               single-line
               bottom
               ></v-select>
        </v-flex>
        <v-flex xs6 pa-3>
          <v-radio-group v-model="platform" label="Platform" row required>
            <v-layout pt-1>
              <v-radio label="THP" value="THP" ></v-radio>
              <v-radio label="SLX" value="SLX"></v-radio>
              <v-radio label="Unk/Both" value="Both"></v-radio>
            </v-layout>
          </v-radio-group>
        </v-flex>
        <v-flex xs6 pa-3>
          <v-checkbox label="This was reported by a customer" v-model="affectingCustomers"></v-checkbox>
        </v-flex>
        <v-flex xs12 pa-3>
          <p>Please give specific details about the issue in the Description section so we can research it quickly. Helpful info includes a link to the order or option, the customer name/email address, and the client name.</p>
          <p>If THP is misbehaving, let us know how you expect it to behave. We understand that you are unhappy when things go wrong. Please don't let your frustration do your communicating. Strong emotions generally slow down the process of resolution so please keep it professional.</p>
          <p>Example: When I opened the order for John Doe under the TravelMax account, I expected to see what he wants for Cable but it doesn't display anything. This is a link to his order: [Put link here] I attached a screenshot.</p>
        </v-flex>
        <v-flex xs12 pa-3>
          <v-text-field v-model="description"
                        label="Description"
                        value="Input text"
                        class="input-group"
                        required
                        multi-line
                        ></v-text-field>
        </v-flex>
        <v-flex xs12 pa-3>
          <v-text-field v-model="stepsToReproduce"
                        label="Steps To Reproduce"
                        value="Input text"
                        class="input-group"
                        required
                        multi-line
                        ></v-text-field>
        </v-flex>
        <v-flex xs12 pa-3 mt-4 mb-4>
          <v-layout column pa-5 id="file-upload" class="wrapper md mx-auto pa-5 my-4" v-bind:class="{valid: images.length}">
            <v-flex mx-auto>
              <span class="title">Upload Screenshots</span>
            </v-flex>
            <v-flex mx-auto pt-4 pb-4>
              <label for="file" class="mx-auto">
                <v-icon class="pa-4"></v-icon>
              </label>
              <input @change="processFile($event)" type="file" name="file" id="file" accept="image/*" multiple>
            </v-flex>
            <transition name="fade" v-for="(image, index) in images" :key="index">
            <v-flex xs10 pa-3 mx-auto v-show="image" >
              <img :src="image">
            </v-flex>
            </transition>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row>
        <div class="controls">
          <v-btn
             @click="submit"
             :disabled="!valid"
             color="success"
             >
             submit
          </v-btn>
            <v-btn @click="clear">clear</v-btn>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';

export default {
  name: 'BugForm',
  data() {
    return {
      success: false,
      error: false,
      valid: false,
      description: '',
      affectingCustomers: false,
      stepsToReproduce: '',
      images: [],
      platform: '',
      severities: [
        { text: 'This is an inconvenience', value: 'Green' },
        { text: 'This is deeply frustrating', value: 'Yellow' },
        { text: 'This is stopping me from working', value: 'Red' }
      ],
      severity: ''
    };
  },
  computed: mapState({
    ...mapState('account', ['user'])
  }),
  methods: {
    ...mapActions({
      successAlert: 'alert/success',
      errorAlert: 'alert/error'
    }),
    processFile(event) {
      this.file = event.target.files[0];
      this.onFileChange(event);
    },
    submit() {
      if (this.$refs.form.validate()) {
        axios
          .post(`${process.env.BASE_URL}/submissions/bugs`, {
            name: this.user.name,
            email: this.user.email,
            severity: this.severity,
            affectingCustomers: this.affectingCustomers,
            platform: this.platform,
            images: this.images,
            description: this.description,
            stepsToReproduce: this.stepsToReproduce,
            createdAt: `${new Date().toLocaleDateString()}`
          })
          .then(result => {
            this.$toastr.s('Bug submitted');
            this.$router.go();
          })
          .catch((err) => {
            this.$toastr.e(`Failed to submit bug ${err}`);
          });
      }
    },
    clear() {
      this.$refs.form.reset();
      this.images = [];
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      Array.from(files).forEach(file => this.createImage(file));
    },
    createImage(file) {
      this.file = event.target.files[0];
      var reader = new FileReader();
      var vm = this;

      reader.onload = e => {
        vm.images.push(e.target.result);
      };
      reader.readAsDataURL(file);
    },
    removeImage: function(e) {
      e.preventDefault();
      e.target.value = '';
    }
  }
};
</script>

<style lang="scss">
@import "./../style/_variables.scss";

#bug-form {
  background-color: $white;
}

#file-upload {
  background-color: $light-gray;
  border: 2px dashed $gray;

  img {
    width: 100%;
  }

  input {
    display: none;
  }

  label {
    background-color: $primary;
    border-radius: 50%;
    box-shadow: $box-shadow-light;
    color: $white;
    cursor: pointer;
    display: block;
    transition: 0.4s all ease-out;

    i {
      color: $white;

      &:before {
        content: "add";
      }
    }

    &:hover {
      box-shadow: $box-shadow-dark;
      transform: scale(1.1);
    }
  }

  &.valid {
    label {
      background-color: #0ac775;

      i {
        &:before {
          content: "done";
        }
      }

      &:hover {
        background-color: #f44a4a;

        i:before {
          content: "add";
        }
      }
    }
  }
}

.controls {
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/BugForm.vue